<template>
  <!--
    	作者：luoyiming
    	时间：2020-06-20
    	描述：diy组件-模拟显示-限时秒杀
    -->
  <div class="drag optional" :class="{ selected: index === selectedIndex }"
    @click.stop="$parent.$parent.onEditer(index)">
    <div class="diy-group" style="background: #ffffff ">
      <img style="345px;height: 230px;" :src="img1" alt="">
    </div>
    <div class="btn-edit-del">
      <div class="btn-del" @click.stop="$parent.$parent.onDeleleItem(index)">{{$t('删除')}}</div>
    </div>
  </div>
</template>

<script>
  import img1 from '@/assets/img/group.png';
  export default {
    data() {
      return {
        /*分类id*/
        category_id: 0,
        img1:img1
      };
    },
    created() {},
    props: ['item', 'index', 'selectedIndex'],
    methods: {
      /*计算宽度*/
      getUlwidth(item) {
        if (item.style.display == 'slide') {
          let total = 0;
          if (item.params.source == 'choice') {
            total = item.data.length;
          } else {
            total = item.defaultData.length;
          }
          let w = 0;
          if (item.style.column == 2) {
            w = total * 150;
          } else {
            w = total * 100;
          }
          return 'width:' + w + 'px;';
        }
      }
    }
  };
</script>

<style>
  .diy-group {
    border-radius: 10px 10px 0 0;
  }

  .diy-group .diy-head {
    padding: 0 10px;
    height: 40px;
  }

  .diy-group .diy-head .name {
    font-size: 18px;
    font-weight: bold;
  }

  .diy-group .diy-head .datetime {
    margin-left: 20px;
  }

  .diy-group .diy-head .datetime>span {
    display: inline-block;
  }

  .diy-group .diy-head .datetime .text {
    padding: 0 2px;
    color: #F6220C;
  }

  .diy-group .diy-head .datetime .box {
    padding: 2px;
    border-radius: 4px;
    background: #FFEBEB;
    color: #F6220C;
  }

  .diy-group .product-list.group {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }


  .diy-group .product-list.group .product-title {
    margin-top: 13px;
    height: 15px;
    line-height: 15px;
    font-size: 14px;
    display: -webkit-box;
    overflow: hidden;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }

  .diy-group .display__list .column__3 {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .diy-group .product-list.group.column__3 .product-item {
    width: 120px;
    margin-bottom: 10px;
    margin-left: 6px;
    background: #ffffff;
  }

  .diy-group .product-list.group.column__3 .product-item .product-cover {
    width: 120px;
    height: 65px;
    overflow: hidden;
  }

  .diy-group .product-list.group.column__3 .product-item .product-cover img {
    width: 120px;
    height: 65px;
    background-color: #F4F4F4;
    border-radius: 6px;
  }
</style>



// WEBPACK FOOTER //
// src/views/page/page/diy/model/Group.vue